import styles from "./ShimmerText.module.css";
import type { TextProps } from "@mantine/core";
import { Text } from "@mantine/core";
import type { ReactNode } from "react";

export default function ShimmerText({ children, ...props }: { children: ReactNode } & TextProps) {
  return (
    <Text {...props} classNames={{ root: styles.root }}>
      {children}
    </Text>
  );
}
